import { createSelector } from '@reduxjs/toolkit';

import { LoadingState } from '@nocowanie/core';

import { sectionToStateKeyMap } from '@app/consts';
import { SectionNameEnum, SliceNameEnum } from '@app/enums';

import { CmsHomepageState } from './cms-homepage.types';

const selectSelfState = (state: { [SliceNameEnum.CmsHomepage]: CmsHomepageState }) => {
    return state[SliceNameEnum.CmsHomepage];
};

const selectSectionData = <T>(section: SectionNameEnum) =>
    createSelector(selectSelfState, state => {
        const stateKey = sectionToStateKeyMap[section];
        if (!stateKey) return null;

        const sectionState = state[stateKey];
        if (!sectionState?.data) return null;

        if (section === SectionNameEnum.HeroSection) {
            return (sectionState.data as any)?.content?.[0];
        }

        return sectionState.data;
    });

const selectSectionLoading = (section: SectionNameEnum) =>
    createSelector(selectSelfState, state => {
        const stateKey = sectionToStateKeyMap[section];
        return stateKey ? state[stateKey].loading : LoadingState.IDLE;
    });

const selectSectionError = (section: SectionNameEnum) =>
    createSelector(selectSelfState, state => {
        const stateKey = sectionToStateKeyMap[section];
        return stateKey ? state[stateKey].error : null;
    });

const selectIsSectionLoading = (section: SectionNameEnum) =>
    createSelector(selectSelfState, state => {
        const stateKey = sectionToStateKeyMap[section];
        return stateKey ? state[stateKey].loading === LoadingState.PENDING : false;
    });

export const selectors = {
    selectSectionData,
    selectSectionLoading,
    selectSectionError,
    selectIsSectionLoading,
};
